module["exports"] = [
  "Արցախի Հանրապետություն"
];
